import * as API from "./API";

export default {
    getRoles(){
       return API.apiClient.get('roles', {
        withCredentials: true
      });
    }
}